import { Injectable } from "@angular/core";
import { LgD3PieInterpolator } from "./lg-d3-pie-interpolator.service";

@Injectable({ providedIn: "root" })
export class LgD3PieInterpolatorFactory {
    interpolator(): LgD3PieInterpolator {
        return new LgD3PieInterpolator();
    }
}
